<template>
  <div class="Review">
    <div class="user">
      <img :src="review.user_avatar" alt="">
      <p>{{review.user_name}}</p>
      <button class="button" @click="onStateChange">{{review.hide_state?'Show':'Hide'}}</button>
    </div>
    <div class="rate">
      <el-rate
        :value="parseInt(review.review_rate)"
        disabled
        show-score
        text-color="#ff9900"
        score-template="{value}">
      </el-rate>
      <p>{{review.review_time}}</p>
    </div>
    <div class="text" v-if="review.review_text">
      <p>{{review.review_text}}</p>
    </div>
    <div class="images" v-if="review.review_images.length!==0">
      <el-image v-for="(image,index) in review.review_images"
                :key="index"
                class="image"
                :src="image"
                fit="cover"
                lazy
                :preview-src-list="review.review_images | sortArr(index)">
      </el-image>
    </div>
    <div class="trace" @click="onTargetClick(review.review_type,review.target_id)">
      <p>On {{review.review_type==='product'?'Product':'Vendor'}}: {{review.target_name}}</p>
      <i class="el-icon-caret-right"></i>
    </div>
  </div>
</template>

<script>
  import {changeReview} from '@/utils/api'
  export default {
    props: ['review'],
    data: () => {
      return {

      }
    },
    methods:{
      onStateChange(){
        let review_id = this.review.review_id;
        let review_type = this.review.review_type;
        let hide_state = this.review.hide_state;
        this.$confirm(`Are you sure you want to ${hide_state?'show':'hide'} this review?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          changeReview(review_type, review_id, !hide_state?1:0).then(res => {
            if (res.errcode === 0) {
              this.review['hide_state'] = !hide_state;
              this.$message({
                type: 'success',
                message: `Review ${!hide_state?'Hidden':'Shown'}!`
              });
            }
          });

        }).catch(() => {});
      },
      onTargetClick(){}
    },
    mounted(){
    }
  };
</script>

<style lang="scss" scoped>
  @import "_Review.scss";
</style>